import { service } from '../../../../helpers/http' 

export const ActionGetInstallments = ({ dispatch }, payload) => { 
    return service({
        module: 'installment',
        action: 'getInstallments',
        payload: payload
    })
}

export const ActionPostInstallments = ({ dispatch }, payload) => {

    return service({
        module: 'installment',
        action: 'postInstallments',
        payload: payload
    })
    
}

export const ActionPutInstallments = ({ dispatch }, payload) => {

    return service({
        module: 'installment',
        action: 'putInstallments',
        payload: payload
    })
    
}

export const ActionDeleteInstallments = ({ dispatch }, payload) => {

    return service({
        module: 'installment',
        action: 'deleteInstallments',
        payload: payload
    })
    
}
